var exports = {
  "x": "xf0b3b88a--1f7662--button",
  "k": "xf0b3b88a--1f7662--button--white",
};

module.exports = exports;
